import type { SnippetBodyFormat, SnippetProduct, SnippetScope } from './types';

const BLOCK_SERVICE_API_URL = '/gateway/api/blocks/v1';
const SNIPPETS_PATH = '/snippets';

export interface FetchSnippetParams {
	format: SnippetBodyFormat;
	product: SnippetProduct;
	scope: SnippetScope;
}

export const fetchSnippets = async (params: FetchSnippetParams) => {
	const queryParams = new URLSearchParams({
		format: params.format,
		product: params.product,
		scope: params.scope,
	});

	const response = await fetch(
		`${BLOCK_SERVICE_API_URL + SNIPPETS_PATH}?${queryParams.toString()}`,
		{
			method: 'GET',
		},
	);

	if (!response.ok) {
		throw new Error('Failed to fetch snippets');
	}
	return await response.json();
};
